/*=========================================================================================
  File Name: state.js
  Description: Vuex Store - state
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

// import navbarSearchAndPinList from "@/layouts/components/navbar/navbarSearchAndPinList"
// import themeConfig from "@/../themeConfig.js"
// import colors from "@/../themeConfig.js"

// /////////////////////////////////////////////
// Variables
// /////////////////////////////////////////////

const userDefaults = {
  uid: 0,          // From Auth
  displayName: "John Doe", // From Auth
  about: "Dessert chocolate cake lemon drops jujubes. Biscuit cupcake ice cream bear claw brownie brownie marshmallow.",
  photoURL: require("@/assets/images/portrait/small/avatar-s-11.jpg"), // From Auth
  status: "online",
  userRole: "admin"
}

// /////////////////////////////////////////////
// State
// /////////////////////////////////////////////

const state = {
  AppActiveUser: userDefaults,
  homeActivity: localStorage.getItem("homeActivity") || false,
  homeCheckAccess: false,
  chatTimeout: false,
  chatTimeoutText: "",
  bodyOverlay: false,
  isVerticalNavMenuActive: true,
  // navbarSearchAndPinList: navbarSearchAndPinList,
  verticalNavMenuWidth: "default",
  verticalNavMenuItemsMin: false,
  scrollY: 0,
  // starredPages: navbarSearchAndPinList["pages"].data.filter((page) => page.is_bookmarked),
  // themePrimaryColor: colors.primary,
  // theme: themeConfig.theme || "light",
  // mainLayoutType: themeConfig.mainLayoutType || "vertical",
  // reduceButton: themeConfig.sidebarCollapsed,

  config: {
    bbva: "",
    SOCKET: "",
    // ID_SENTRY: ""
  },

  session: {
    token: ""
  },

  enviromentSetting: {
    title: "vamos ggssef"
  },

  search: {
    text: "",
  },

  logId: 0,

  activeArticle: localStorage.getItem('activeArticle') === 'true',

  activeModalLeaveVote: false,
  // Can be used to get current window with
  // Note: Above breakpoint state is for internal use of sidebar & navbar component
  windowWidth: null,

  sosModal: false,

  agent: false,

  directLinkChat: false
}

export default state
